// extracted by mini-css-extract-plugin
export default {"propertySelector":"PropertySelector_propertySelector__gqVSA"};